import React from "react";
import { Link } from "react-router-dom";
import { Warning } from "@phosphor-icons/react";

export const DriveWarning = () => (
    <div
        className="border border-orange-700/60 bg-orange-950/30 p-4 flex items-start gap-3"
        data-testid="editor-drive-warning"
    >
        <Warning size={20} weight="fill" className="text-orange-400 shrink-0 mt-0.5" />
        <div className="flex-1">
            <div className="font-mono text-[10px] uppercase tracking-[0.25em] text-orange-300 mb-1">
                Google Drive not connected
            </div>
            <p className="text-xs text-zinc-300 leading-relaxed">
                Hero + inline image uploads need your Google Drive.{" "}
                <Link to="/admin" className="underline hover:text-[#FFD000]">
                    Connect it from the dashboard
                </Link>{" "}
                before uploading images for this post.
            </p>
        </div>
    </div>
);
